export type RecordingStudioPreRollSeconds = 0 | 2 | 4 | 8

export const DEFAULT_PARTIAL_RECORDING_ENABLED = false
export const DEFAULT_RECORDING_START_MS = 0
export const DEFAULT_PRE_ROLL_SECONDS: RecordingStudioPreRollSeconds = 4
export const MAX_RECORDING_START_MS = 24 * 60 * 60 * 1000

export function normalizeTimelineStartMs(value: unknown): number {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return 0
  return Math.min(MAX_RECORDING_START_MS, Math.max(0, Math.round(numeric)))
}

export function normalizePreRollSeconds(value: unknown): RecordingStudioPreRollSeconds {
  const numeric = Number(value)
  return numeric === 2 || numeric === 4 || numeric === 8 ? numeric : 0
}

export function formatTimelinePosition(valueMs: unknown): string {
  const totalSeconds = Math.floor(normalizeTimelineStartMs(valueMs) / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export function parseTimelinePosition(value: string): number | null {
  const trimmed = value.trim()
  const match = /^(\d{1,3}):([0-5]\d)$/.exec(trimmed)
  if (!match) return null
  const minutes = Number(match[1])
  const seconds = Number(match[2])
  return normalizeTimelineStartMs((minutes * 60 + seconds) * 1000)
}

export function preRollWindow(startMs: unknown, preRollSeconds: unknown): {
  playbackStartMs: number
  durationMs: number
} {
  const target = normalizeTimelineStartMs(startMs)
  const requested = normalizePreRollSeconds(preRollSeconds) * 1000
  const durationMs = Math.min(target, requested)
  return { playbackStartMs: target - durationMs, durationMs }
}
